interface CreateFileParams {
    filename: string
    filetype: string
    data: any,
}

//'application/pdf'

export const createFile = (params: CreateFileParams) => {
    const blob = new Blob([params.data], { type: params.filetype })
    if (window.navigator['msSaveOrOpenBlob']) {
        window.navigator['msSaveBlob'](blob, params.filename)
    }
    else {
        const elem = window.document.createElement('a')
        elem.href = window.URL.createObjectURL(blob)
        elem.download = params.filename
        document.body.appendChild(elem)
        elem.click()
        document.body.removeChild(elem)
        window.URL.revokeObjectURL(elem.href)
    }
}

export const downloadFile = (url: string, name = 'fichier.txt') => {

    const hidden_a = document.createElement('a');

    hidden_a.setAttribute('href', url);

    hidden_a.setAttribute('download', name);
    document.body.appendChild(hidden_a);

    hidden_a.click();
    document.body.removeChild(hidden_a);
}

export const csvEscape = (value: unknown): string => {
    const s = value === null || value === undefined ? '' : String(value)
    if (/[",\r\n]/.test(s)) {
        return '"' + s.replace(/"/g, '""') + '"'
    }
    return s
}

export const csvStringify = (rows: unknown[][]): string => {
    return rows.map((r) => r.map(csvEscape).join(',')).join('\r\n')
}

export const csvParse = (text: string): string[][] => {
    if (text.charCodeAt(0) === 0xfeff) text = text.slice(1)
    const rows: string[][] = []
    let row: string[] = []
    let field = ''
    let inQuotes = false
    let i = 0
    while (i < text.length) {
        const ch = text[i]
        if (inQuotes) {
            if (ch === '"') {
                if (text[i + 1] === '"') { field += '"'; i += 2; continue }
                inQuotes = false; i++; continue
            }
            field += ch; i++; continue
        }
        if (ch === '"') { inQuotes = true; i++; continue }
        if (ch === ',') { row.push(field); field = ''; i++; continue }
        if (ch === '\r') {
            if (text[i + 1] === '\n') i++
            row.push(field); rows.push(row); row = []; field = ''; i++; continue
        }
        if (ch === '\n') {
            row.push(field); rows.push(row); row = []; field = ''; i++; continue
        }
        field += ch; i++
    }
    if (field.length > 0 || row.length > 0) {
        row.push(field); rows.push(row)
    }
    return rows
}

export const downloadCSV = (filename: string, rows: unknown[][]) => {
    const bom = '﻿'
    createFile({
        filename,
        filetype: 'text/csv;charset=utf-8',
        data: bom + csvStringify(rows)
    })
}

export const readCSVFile = (file: File): Promise<string[][]> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => {
            try {
                resolve(csvParse(String(reader.result || '')))
            } catch (err) {
                reject(err)
            }
        }
        reader.onerror = () => reject(reader.error)
        reader.readAsText(file, 'UTF-8')
    })
}

declare global {
    interface Navigator {
        msSaveOrOpenBlob: (blobOrBase64: Blob | string, filename: string) => void
        msSaveBlob: (blobOrBase64: Blob | string, filename: string) => void
    }
  }